import * as React from "react";
import { getCompanyCwUrl } from "../../libs/chartec_cw";
import styled from "styled-components";

interface IProps {
  org: IOrganization;
  cw: IJsonApiResponse<ICwMemberRecord>;
}

const CWtd = styled.td`
  padding: 5px;
`;

function OrgCW({ org, cw }: IProps) {

  const cwData = (cw && cw.data && cw.data.attributes) ? cw.data.attributes : null;

  return (
    <>
    {
      cwData
      ? (
          <table>
            <tbody>
              <tr>
                <CWtd><strong>Rec ID:</strong></CWtd>
                <CWtd>{cwData.cwRecid}</CWtd>
              </tr>
              <tr>
                <CWtd><strong>Company ID:</strong></CWtd>
                <CWtd>{cwData.cwCompanyid}</CWtd>
              </tr>
              <tr>
                <CWtd>
                  <a
                    target={"_blank"}
                    href={getCompanyCwUrl(cwData.cwRecid)}
                    role={"button"}
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-external-link"></i>&nbsp;
                    View in ConnectWise
                  </a>
                </CWtd>
              </tr>
            </tbody>
          </table>
        )
      : (
          <div>
            No ConnectWise Member Data
          </div>
        )
    }
    </>
  );
}
export default OrgCW;



// WEBPACK FOOTER //
// ./app/javascript/components/org/OrgCW.tsx